import { type Reducer } from 'redux';

import {
  type resetAVSessionToken,
  type setAVSessionToken,
  type setAVSessionTokenLoading,
  ACTIONS,
} from '@~/actions/av/av-session-token';

interface AVSessionTokenInitialState {
  [teacherClassroomId: string]: {
    loading: boolean;
    sessionId?: string | Error;
    authToken?: string | Error;
    authTokenForDisplay?: string | Error;
    livekitUrl?: string | Error;
  };
}

type AVSessionTokenRedcuder = Reducer<
  AVSessionTokenInitialState,
  | ReturnType<typeof setAVSessionTokenLoading>
  | ReturnType<typeof setAVSessionToken>
  | ReturnType<typeof resetAVSessionToken>
>;

const initialState: AVSessionTokenInitialState = {};

const reducer: AVSessionTokenRedcuder = (state = initialState, action) => {
  const { type } = action;

  if (type === ACTIONS.SET_AV_SESSION_TOKEN_LOADING) {
    const { teacherClassroomId } = action.payload;

    return {
      [teacherClassroomId]: {
        ...state[teacherClassroomId],
        sessionId: undefined,
        authToken: undefined,
        authTokenForDisplay: undefined,
        livekitUrl: undefined,

        loading: true,
      },
    };
  }

  if (type === ACTIONS.SET_AV_SESSION_TOKEN) {
    const { teacherClassroomId } = action.payload;

    return {
      [teacherClassroomId]: {
        ...state[teacherClassroomId],
        loading: false,
        sessionId: action.payload.sessionId,
        authToken: action.payload.authToken,
        authTokenForDisplay: action.payload.authTokenForDisplay,
        livekitUrl: action.payload.livekitUrl,
      },
    };
  }

  if (type === ACTIONS.RESET_AV_SESSION_TOKEN) {
    return initialState;
  }

  return state;
};

export default reducer;
